import { IsNotEmpty } from 'class-validator';

export class Property {
  @IsNotEmpty()
  name: string;
  
  @IsNotEmpty()
  value: any;
}